import Button from '../../Common/Button';
import ColumnOrder from '../ColumnOrder/ColumnOrder';
import ExportToExcel from '../Export/ExportToExcel';
import ExportToPDF from '../Export/ExportToPDF';
import update from '../../../../assets/img/svg/buttons/update.svg';
import { useHeaderConfig } from '../../../../hook/useHeaderConfig';
import { t } from 'i18next';
import { useAllFilters } from '../../../../hook/useAllFilters';
import { useMenus } from '../../../../hook/useMenus';

const DesktopFilters: React.FC = () => {
  const { handleApplyAllFilters } = useAllFilters();

  const menus = useMenus();
  const headerConfig = useHeaderConfig(menus);

  return (
    <>
      {headerConfig.updateData && (
        <Button
          icon={update}
          variant="filled"
          className="update_data"
          onClick={handleApplyAllFilters}
          testId="updatedata"
        >
          {t('statisticPage.header.buttons.updateData')}
        </Button>
      )}
      {headerConfig.columnOrder && <ColumnOrder />}
      {headerConfig.exportToExcel && <ExportToExcel />}
      {headerConfig.exportToPDF && <ExportToPDF />}
    </>
  );
};
export default DesktopFilters;
